export var MatchCityStateOption;
(function (MatchCityStateOption) {
    MatchCityStateOption["ENABLED"] = "True";
    MatchCityStateOption["DISABLED"] = "False";
})(MatchCityStateOption || (MatchCityStateOption = {}));
